export interface DownloadBlobOptions {
  data: Blob | ArrayBuffer;
  defaultFileName: string;
  contentDisposition?: string;
}

/** `{name}_Import_Template_{yyyy-MM-dd}.xlsx` — instrument import template download name. */
export function datedImportSampleFileName(name: string, date = new Date()): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${name}_Import_Template_${yyyy}-${mm}-${dd}.xlsx`;
}

export function downloadBlob({ data, defaultFileName, contentDisposition }: DownloadBlobOptions): void {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
    link.download = match?.[1] ?? defaultFileName;
  } else {
    link.download = defaultFileName;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
